import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { getFileTypeByCode } from '../../slices/thunks';


const useFileType = (code) => {
    const dispatch = useDispatch();

    const selector = createSelector(
        state => state.FileManager,
        data => ({
            file_type: data.file_type,
        })
    );

    const { file_type } = useSelector(selector);

    useEffect(() => {
        if (code) {
            dispatch(getFileTypeByCode(code));
        }
    }, [dispatch, code]);
    
    return { file_type };
}

export default useFileType;